<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Template -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{'loading-mask': loading}">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Teaplate name</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Sender name (use as the sender of the message)</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.sender_name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Sender address - ({sender address}@domain.com)</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.sender_address">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">tag</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.tag">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Subject</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.subject">
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-6">
                            <ace-editor :editor-id="'query_editor'" @change-content="contentChanged" :content="form.content || ''" lang="html" theme="monokai" v-bind:style="{'width':'100%', height: '600px'}"></ace-editor>
                        </div>

                        <div class="col-lg-6 msg-container" style="padding: 0; height: 600px">
                            <div style="height: 98%; background: white">
                                <iframe id="asd" frameBorder="0" style="border: 1px solid grey; width:99%; height: 95%; margin: 5px;"></iframe>
                            </div>
                        </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{err}}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import aceEditor from '../common/Ace.js'

export default {
    components: { modal, aceEditor },
    props: {
        id: null,
    },
    data() {
        return {
            form: {
                _id: null,
                name: null,
                content: null,
                tag:null,
                subject: null,
                sender_name: null,
                sender_address: null
            },
            err: null,
            loading: false,
        }
    },
    methods: {
        save() {
            this.loading = true
            this.$api.postReq('template', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
            }).catch(res => {
                this.err = res.body.error
            })
        },
        contentChanged(c) {
            this.form.content = c
            let iframe = document.getElementById('asd')
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(c);
            iframe.contentWindow.document.close();
        },
    },
    mounted() {

        if (typeof this.id !== 'string') {
            return
        }

        this.$api.getReq('template/'+this.id).then(res => {
            this.form._id = this.id
            this.form.name = res.data.data.name
            this.form.content = res.data.data.content
            this.form.tag = res.data.data.tag
            this.form.subject = res.data.data.subject
            this.form.sender_name = res.data.data.sender_name
            this.form.sender_address = res.data.data.sender_address
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/Template.vue